module.exports = __webpack_public_path__ + "img/场景图.808cb857.png";